export const iohLevelOneTerminalPositions = [
  {
    uid: '4',
    schematicId: '441',
    name: 'BEDFORD PARK',
    abbrevation: 'BED',
    code: 'BEDTRM',
    startX: 53,
    startY: 205,
    direction: 5,
    milepost: '000ZA3'
  },
  {
    uid: '5',
    schematicId: '551',
    name: 'BESSEMER',
    abbrevation: 'BES',
    code: 'BESTRM',
    startX: 245,
    startY: 765,
    direction: 5,
    milepost: '0LB407'
  },
  {
    uid: '6',
    schematicId: '661',
    name: 'BUFFALO ICTF',
    abbrevation: 'BUF',
    code: 'BUFTRM',
    startX: 1224,
    startY: 65,
    direction: 5,
    milepost: 'QD   6'
  },
  {
    uid: '8',
    schematicId: '881',
    name: 'CCX',
    abbrevation: 'CCX',
    code: 'CCXTRM',
    startX: 1606,
    startY: 626,
    direction: 5,
    milepost: 'A  116'
  },
  {
    uid: '10',
    schematicId: '10101',
    name: 'CHAMBERSBURG',
    code: 'CHATRM',
    abbrevation: 'CHA',
    startX: 1607,
    startY: 345,
    direction: 5,
    milepost: 'BAV 21'
  },
  {
    uid: '11',
    schematicId: '11111',
    name: 'CHARLESTON',
    abbrevation: 'CHS',
    code: 'CHSTRM',
    startX: 1016,
    startY: 625,
    direction: 5,
    milepost: 'A  390'
  },
  {
    uid: '12',
    schematicId: '12121',
    name: 'CHARLOTTE',
    abbrevation: 'CNC',
    code: 'CNCTRM',
    startX: 1398,
    startY: 625,
    direction: 5,
    milepost: 'SF 330'
  },
  {
    uid: '2',
    schematicId: '221',
    name: 'CHICAGO 59TH STREET',
    abbrevation: 'FIV',
    code: 'FIVTRM',
    startX: 53,
    startY: 65,
    direction: 5,
    milepost: 'DCQ 25'
  },
  {
    uid: '14',
    schematicId: '14141',
    name: 'CINCINNATI',
    code: 'CINTRM',
    abbrevation: 'CIN',
    startX: 630,
    startY: 345,
    direction: 5,
    milepost: '00T110'
  },
  {
    uid: '15',
    schematicId: '15151',
    name: 'CLEVELAND',
    abbrevation: 'CLE',
    code: 'CLETRM',
    startX: 1224,
    startY: 205,
    direction: 5,
    milepost: 'QD 173'
  },
  {
    uid: '16',
    schematicId: '16161',
    name: 'COLUMBUS',
    abbrevation: 'COL',
    code: 'COLTRM',
    startX: 1014,
    startY: 345,
    direction: 5,
    milepost: 'QTB  2'
  },
  {
    uid: '18',
    schematicId: '18181',
    name: 'DETROIT',
    abbrevation: 'DET',
    code: 'DETTRM',
    startX: 1014,
    startY: 65,
    direction: 5,
    milepost: 'QQM  2'
  },
  {
    uid: '21',
    schematicId: '21211',
    name: 'EAST ST LOUIS',
    abbrevation: 'EST',
    code: 'ESTTRM',
    startX: 53,
    startY: 345,
    direction: 5,
    milepost: 'QS 235'
  },
  {
    uid: '23',
    schematicId: '23231',
    name: 'FAIRBURN',
    code: 'FABTRM',
    abbrevation: 'FAB',
    startX: 630,
    startY: 765,
    direction: 5,
    milepost: 'XXB023'
  },
  {
    uid: '30',
    schematicId: '30301',
    name: 'INDIANAPOLIS ICTF',
    abbrevation: 'INR',
    code: 'INRTRM',
    startX: 438,
    startY: 345,
    direction: 5,
    milepost: 'QS   9'
  },
  {
    uid: '29',
    schematicId: '29291',
    name: 'INDIANAPOLIS',
    code: 'INDTRM',
    abbrevation: 'IND',
    startX: 245,
    startY: 345,
    direction: 5,
    milepost: 'QS   9'
  },
  {
    uid: '20',
    schematicId: '20201',
    name: 'JACKSONVILLE',
    abbrevation: 'JAX',
    code: 'JAXTRM',
    startX: 820,
    startY: 765,
    direction: 5,
    milepost: 'A  640'
  },
  {
    uid: '31',
    schematicId: '31311',
    name: 'KEARNY',
    abbrevation: 'KRN',
    code: 'KRNTRM',
    startX: 1800,
    startY: 205,
    direction: 5,
    milepost: 'QK   3'
  },
  {
    uid: '33',
    schematicId: '33331',
    name: 'LOUISVILLE',
    abbrevation: 'LOU',
    code: 'LOUTRM',
    startX: 245,
    startY: 485,
    direction: 5,
    milepost: '000006'
  },
  {
    uid: '37',
    schematicId: '37371',
    name: 'MEMPHIS',
    abbrevation: 'MEM',
    code: 'MEMTRM',
    startX: 56,
    startY: 628,
    direction: 5,
    milepost: '00F371'
  },
  {
    uid: '39',
    schematicId: '39391',
    name: 'NASHVILLE',
    abbrevation: 'NSH',
    code: 'NSHTRM',
    startX: 248,
    startY: 628,
    direction: 5,
    milepost: '000190'
  },
  {
    uid: '41',
    schematicId: '41411',
    name: 'NEW ORLEANS',
    code: 'NOLTRM',
    abbrevation: 'NOL',
    startX: 53,
    startY: 905,
    direction: 5,
    milepost: '000801'
  },
  {
    uid: '42',
    schematicId: '42421',
    name: 'NORTH BERGEN',
    abbrevation: 'NBE',
    code: 'NBETRM',
    startX: 1607,
    startY: 205,
    direction: 5,
    milepost: 'QR   1'
  },
  {
    uid: '43',
    schematicId: '43431',
    name: 'NORTHWEST OHIO',
    abbrevation: 'NOW',
    code: 'NOWTRM',
    startX: 820,
    startY: 205,
    direction: 5,
    milepost: 'BI  51'
  },
  {
    uid: '44',
    schematicId: '44441',
    name: 'PHILADELPHIA',
    abbrevation: 'PHI',
    code: 'PHITRM',
    startX: 1800,
    startY: 345,
    direction: 5,
    milepost: 'BBF  8'
  },
  {
    uid: '50',
    schematicId: '50501',
    name: 'SAVANNAH',
    abbrevation: 'SAV',
    code: 'SAVTRM',
    startX: 824,
    startY: 625,
    direction: 5,
    milepost: 'A  496'
  },
  {
    uid: '54',
    schematicId: '54541',
    name: 'SPRINGFIELD',
    abbrevation: 'SPR',
    code: 'SPRTRM',
    startX: 1800,
    startY: 65,
    direction: 5,
    milepost: 'QB 100'
  },
  {
    uid: '55',
    schematicId: '55551',
    name: 'SYRACUSE',
    code: 'SYRTRM',
    abbrevation: 'SYR',
    startX: 1416,
    startY: 65,
    direction: 5,
    milepost: 'QC 285'
  },
  {
    uid: '56',
    schematicId: '56561',
    name: 'TAMPA',
    abbrevation: 'TAM',
    code: 'TAMTRM',
    startX: 630,
    startY: 905,
    direction: 5,
    milepost: 'S  841'
  },
  {
    uid: '9',
    schematicId: '991',
    name: 'WINTER HAVEN',
    abbrevation: 'WIN',
    code: 'WINTRM',
    startX: 824,
    startY: 905,
    direction: 5,
    milepost: 'SX 833'
  },
  {
    uid: '63',
    schematicId: '63631',
    name: 'WORCESTER',
    abbrevation: 'WOR',
    code: 'WORTRM',
    startX: 1993,
    startY: 65,
    direction: 5,
    milepost: 'QB  45'
  }
];

export let iohLevelOneCorridorPositions = [
  {
    abbreviation: 'IND',
    approachingNodes: [
      {
        abbrevation: 'CHG',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'INR',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'TER',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'CHG',
    approachingNodes: [
      {
        abbrevation: 'BED',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'DESH',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'FIV',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'GRP',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'IND',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'TER',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'FAB',
    approachingNodes: [
      {
        abbrevation: 'ATL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'LAG',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'MAN',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'CVL',
    approachingNodes: [
      {
        abbrevation: 'ETO',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'ATL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'NSH',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'ATL',
    approachingNodes: [
      {
        abbrevation: 'FAB',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'CVL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'GWD',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'VIT',
    approachingNodes: [
      {
        abbrevation: 'JAX',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'TAM',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'WIN',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'JAX',
    approachingNodes: [
      {
        abbrevation: 'VIT',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'WAX',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'CLE',
    approachingNodes: [
      {
        abbrevation: 'BUF',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'GRN',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'BUF',
    approachingNodes: [
      {
        abbrevation: 'CLE',
        tablePosition: {
          startX: 2315,
          startY: 470,
          sortOrder: 1
        },
        arrowDirection: 1,
        trainCount: 2
      },
      {
        abbrevation: 'SYR',
        tablePosition: {
          startX: 2330,
          startY: 250,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 1
      }
    ]
  },
  {
    abbreviation: 'NSH',
    approachingNodes: [
      {
        abbrevation: 'BES',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'CVL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'LOU',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'MEM',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'TER',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'BES',
    approachingNodes: [
      {
        abbrevation: 'LAG',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'MTG',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'NSH',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'MTG',
    approachingNodes: [
      {
        abbrevation: 'BES',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'LAG',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'NOL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'SPR',
    approachingNodes: [
      {
        abbrevation: 'SEL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'WOR',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'SEL',
    approachingNodes: [
      {
        abbrevation: 'NBE',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'SPR',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'SYR',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'GAL',
    approachingNodes: [
      {
        abbrevation: 'FOS',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'NOW',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'RID',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'TOL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'FOS',
    approachingNodes: [
      {
        abbrevation: 'GAL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'GRN',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'TOL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'INR',
    approachingNodes: [
      {
        abbrevation: 'HLT',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'IND',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'LOU',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'SID',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'WEL',
    approachingNodes: [
      {
        abbrevation: 'CCX',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'POR',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'RIC',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'RIC',
    approachingNodes: [
      {
        abbrevation: 'SCO',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'WAS',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'WEL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'GRN',
    approachingNodes: [
      {
        abbrevation: 'CHY',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'CLE',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'FOS',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'RID',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'CHY',
    approachingNodes: [
      {
        abbrevation: 'CHA',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'GRN',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'WAS',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'NOW',
    approachingNodes: [
      {
        abbrevation: 'DESH',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'GAL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'DESH',
    approachingNodes: [
      {
        abbrevation: 'CHG',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'NOW',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'SID',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'TOL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'TOL',
    approachingNodes: [
      {
        abbrevation: 'DESH',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'DET',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'FOS',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'GAL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'ETO',
    approachingNodes: [
      {
        abbrevation: 'CIN',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'CVL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'CIN',
    approachingNodes: [
      {
        abbrevation: 'ETO',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'HLT',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'LOU',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'SCO',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'CHA',
    approachingNodes: [
      {
        abbrevation: 'CHY',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'PHI',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'HLT',
    approachingNodes: [
      {
        abbrevation: 'CIN',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'INR',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'SID',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'RID',
    approachingNodes: [
      {
        abbrevation: 'COL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'GAL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'GRN',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'SID',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'DILL',
    approachingNodes: [
      {
        abbrevation: 'CCX',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'CHS',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'MNR',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'CNC',
    approachingNodes: [
      {
        abbrevation: 'MNR',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'WAS',
    approachingNodes: [
      {
        abbrevation: 'AMP',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'CHY',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'RIC',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'SYR',
    approachingNodes: [
      {
        abbrevation: 'BUF',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'MAS',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'SEL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'LAG',
    approachingNodes: [
      {
        abbrevation: 'BES',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'FAB',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'MAN',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'MTG',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'SBG',
    approachingNodes: [
      {
        abbrevation: 'GWD',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'SAV',
    approachingNodes: [
      {
        abbrevation: 'CHS',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'GWD',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'WAX',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'GWD',
    approachingNodes: [
      {
        abbrevation: 'ATL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'SAV',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'SBG',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'MNR',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'MNR',
    approachingNodes: [
      {
        abbrevation: 'CNC',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'DILL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'GWD',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'MAS',
    approachingNodes: [
      {
        abbrevation: 'SYR',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'TER',
    approachingNodes: [
      {
        abbrevation: 'CHG',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'EST',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'IND',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'NSH',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'SID',
    approachingNodes: [
      {
        abbrevation: 'DESH',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'HLT',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'INR',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'RID',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'CHS',
    approachingNodes: [
      {
        abbrevation: 'DILL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'SAV',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'LOU',
    approachingNodes: [
      {
        abbrevation: 'CIN',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'INR',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'NSH',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'PHI',
    approachingNodes: [
      {
        abbrevation: 'AMP',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'CHA',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'KRN',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'KRN',
    approachingNodes: [
      {
        abbrevation: 'NBE',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'PHI',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'POR',
    approachingNodes: [
      {
        abbrevation: 'WEL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'NOL',
    approachingNodes: [
      {
        abbrevation: 'MTG',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'WAX',
    approachingNodes: [
      {
        abbrevation: 'JAX',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'MAN',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'SAV',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'CCX',
    approachingNodes: [
      {
        abbrevation: 'DILL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'WEL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'COL',
    approachingNodes: [
      {
        abbrevation: 'RID',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'SCO',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'MAN',
    approachingNodes: [
      {
        abbrevation: 'FAB',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'LAG',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'WAX',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'NBE',
    approachingNodes: [
      {
        abbrevation: 'KRN',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'SEL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'SCO',
    approachingNodes: [
      {
        abbrevation: 'CIN',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'COL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'RIC',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'EST',
    approachingNodes: [
      {
        abbrevation: 'TER',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'TAM',
    approachingNodes: [
      {
        abbrevation: 'VIT',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'AMP',
    approachingNodes: [
      {
        abbrevation: 'PHI',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      },
      {
        abbrevation: 'WAS',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'WOR',
    approachingNodes: [
      {
        abbrevation: 'SPR',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'FIV',
    approachingNodes: [
      {
        abbrevation: 'CHG',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'GRP',
    approachingNodes: [
      {
        abbrevation: 'CHG',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'DET',
    approachingNodes: [
      {
        abbrevation: 'TOL',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'WIN',
    approachingNodes: [
      {
        abbrevation: 'VIT',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'BED',
    approachingNodes: [
      {
        abbrevation: 'CHG',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  },
  {
    abbreviation: 'MEM',
    approachingNodes: [
      {
        abbrevation: 'NSH',
        tablePosition: {
          startX: 0,
          startY: 0,
          sortOrder: 1
        },
        arrowDirection: 6,
        trainCount: 3
      }
    ]
  }
];

export const Terminals = [
  {
    uid: '48',
    terminalName: 'RICHMOND JUNCTION',
    code: 'RICTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '54',
    terminalName: 'SPRINGFIELD TERMINAL',
    code: 'SPRTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '59',
    terminalName: 'VITIS JUNCTION',
    code: 'VITTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '43',
    terminalName: 'NWOH TERMINAL',
    code: 'NOWTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '9',
    terminalName: 'WINTER HAVEN TERMINAL',
    code: 'WINTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '2',
    terminalName: 'CHICAGO 59TH STREET TERMINAL',
    code: 'FIVTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '84',
    terminalName: 'CHERRY RUN JUNCTION',
    code: 'CHYTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '6',
    terminalName: 'BUFFALO ICTF TERMINAL',
    code: 'BUFTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '56',
    terminalName: 'TAMPA TERMINAL',
    code: 'TAMTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '33',
    terminalName: 'LOUISVILLE TERMINAL',
    code: 'LOUTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '21',
    terminalName: 'EAST ST LOUIS TERMINAL',
    code: 'ESTTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '15',
    terminalName: 'CLEVELAND TERMINAL',
    code: 'CLETRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '19',
    terminalName: 'DILLON JUNCTION',
    code: 'DILLTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '38',
    terminalName: 'MONTGOMERY JUNCTION',
    code: 'MTGTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '46',
    terminalName: 'SCIOTOVILLE JUNCTION',
    code: 'SCOTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '57',
    terminalName: 'TERRE HAUTE JUNCTION',
    code: 'TERTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '37',
    terminalName: 'MEMPHIS TERMINAL',
    code: 'MEMTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '42',
    terminalName: 'NORTH BERGEN TERMINAL',
    code: 'NBETRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '32',
    terminalName: 'LAGRANGE JUNCTION',
    code: 'LAGTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '26',
    terminalName: 'GRAND RAPIDS JUNCTION',
    code: 'GRPTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '27',
    terminalName: 'GREENWHICH JUNCTION',
    code: 'GRNTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '30',
    terminalName: 'INDIANAPOLIS ICTF TERMINAL',
    code: 'INRTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '50',
    terminalName: 'SAVANNAH TERMINAL',
    code: 'SAVTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '11',
    terminalName: 'CHARLESTON TERMINAL',
    code: 'CHSTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '25',
    terminalName: 'GALATEA JUNCTION',
    code: 'GALTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '28',
    terminalName: 'HAMILTON JUNCTION',
    code: 'HLTTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '39',
    terminalName: 'NASHVILLE TERMINAL',
    code: 'NSHTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '58',
    terminalName: 'TOLEDO JUNCTION',
    code: 'TOLTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '41',
    terminalName: 'NEW ORLEANS TERMINAL',
    code: 'NOLTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '4',
    terminalName: 'BEDFORD PARK TERMINAL',
    code: 'BEDTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '31',
    terminalName: 'KEARNY TERMINAL',
    code: 'KRNTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '3',
    terminalName: 'AMPORTS TERMINAL',
    code: 'AMPTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '60',
    terminalName: 'WASHINGTON DC JUNCTION',
    code: 'WASTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '51',
    terminalName: 'SELKIRK JUNCTION',
    code: 'SELTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '52',
    terminalName: 'SIDNEY JUNCTION',
    code: 'SIDTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '63',
    terminalName: 'WORCESTER TERMINAL',
    code: 'WORTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '10',
    terminalName: 'CHAMBERSBURG TERMINAL',
    code: 'CHATRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '23',
    terminalName: 'FAIRBURN TERMINAL',
    code: 'FABTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '8',
    terminalName: 'CCX TERMINAL',
    code: 'CCXTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '61',
    terminalName: 'WAYCROSS JUNCTION',
    code: 'WAXTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '14',
    terminalName: 'CINCINNATI TERMINAL',
    code: 'CINTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '44',
    terminalName: 'PHILDELPHIA TERMINAL',
    code: 'PHITRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '12',
    terminalName: 'CHARLOTTE TERMINAL',
    code: 'CNCTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '36',
    terminalName: 'MASSENA JUNCTION',
    code: 'MASTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '7',
    terminalName: 'CARTERSVILLE JUNCTION',
    code: 'CVLTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '16',
    terminalName: 'COLUMBUS TERMINAL',
    code: 'COLTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '18',
    terminalName: 'DETROIT TERMINAL',
    code: 'DETTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '55',
    terminalName: 'SYRACUSE TERMINAL',
    code: 'SYRTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '22',
    terminalName: 'ETOWAH JUNCTION',
    code: 'ETOTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '47',
    terminalName: 'PORTSMOUTH TERMINAL',
    code: 'PSMTTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '49',
    terminalName: 'RIDGEWAY JUNCTION',
    code: 'RIDTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '24',
    terminalName: 'FOSTORIA JUNCTION',
    code: 'FOSTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '29',
    terminalName: 'INDIANAPOLIS TERMINAL',
    code: 'INDTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '5',
    terminalName: 'BESSEMER TERMINAL',
    code: 'BESTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '13',
    terminalName: 'CHICAGO JUNCTION',
    code: 'CHGTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '53',
    terminalName: 'SPARTANBURG JUNCTION',
    code: 'SBGTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '20',
    terminalName: 'JACKSONVILLE TERMINAL',
    code: 'JAXTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '35',
    terminalName: 'MANCHESTER JUNCTION',
    code: 'MANTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '62',
    terminalName: 'WELDON JUNCTION',
    code: 'WELTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '17',
    terminalName: 'DESHLER JUNCTION',
    code: 'DESHTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '85',
    terminalName: 'ATLANTA JUNCTION',
    code: 'ATLTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '86',
    terminalName: 'GREENWOOD JUNCTION',
    code: 'GWDTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  },
  {
    uid: '87',
    terminalName: 'MONROE JUNCTION',
    code: 'MNRTRM',
    gisSchematicLevel: '2',
    trainAwaitingDeparture: []
  }
];

export const MILEPOSTS = [
  '000ZA3',
  '0LB407',
  'QD   6',
  'A  116',
  'BAV 21',
  'A  390',
  'SF 330',
  'DCQ 25',
  '00T110',
  'QD 173',
  'QTB  2',
  'QQM  2',
  'QS 235',
  'XXB023',
  'QS   9',
  'QS   9',
  'A  640',
  'QK   3',
  '000006',
  '00F371',
  '000190',
  '000801',
  'QR   1',
  'BI  51',
  'BBF  8',
  'A  496',
  'QB 100',
  'QC 285',
  'S  841',
  'SX 833',
  'QB  45'
];
